/**
 * 主题切换：左上→右下斜めワイプ（View Transition）
 * 未対応ブラウザ / prefers-reduced-motion 時は即時切替
 * @param {() => void} applyTheme - 実際にテーマを切り替える関数
 */
export function runThemeViewTransition(applyTheme) {
  const doc = document
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (typeof doc.startViewTransition !== 'function' || prefersReduced) {
    applyTheme()
    return
  }

  const transition = doc.startViewTransition(() => {
    applyTheme()
  })

  transition.ready.then(() => {
    doc.documentElement.animate(
      {
        // 左上コーナーを起点に、斜めの境界線が右下コーナーへ移動していくワイプ
        clipPath: [
          'polygon(0% 0%, 0% 0%, 0% 0%)',
          'polygon(0% 0%, 200% 0%, 0% 200%)',
        ],
      },
      {
        duration: 900,
        easing: 'ease-in-out',
        pseudoElement: '::view-transition-new(root)',
      },
    )
  }).catch(() => {
    // ready が reject されてもテーマ自体は既に切り替わっている
  })
}
